import useIsEmea from "@dana/Common/Hooks/useIsEmea";
import MessageIcon from "@dana/Icons/MessageIcon";
import PlusIcon from "@dana/Icons/PlusIcon";
import PrintIcon from "@dana/Icons/PrintIcon";
import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { CreditMemoDetails, printCreditMemoPdf, SalseOrgDetails } from "@dana/Services/CreditService";
import { getDanaGeneralSettings } from "@dana/Store/Context/ContextSelectors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import sareCreditMomo from "@dana/Store/Data/ViewCredit/Handlers/ShareViewCreditHandler";
import { formatDecimal } from "@dana/utils/utils";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import { DataTableHeaderPresentationProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Img from "@insite/mobius/Img";
import {
    CheckboxGroup,
    DataTable,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
    LoadingOverlay,
} from "@insite/mobius/index";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import TextField from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface ViewCreditTableStyle {
    logoWrapper?: GridItemProps;
    creditMemoAddress?: GridItemProps;
    creditMemoAddressHeading?: TypographyPresentationProps;
    creditMemoAddressDescription?: TypographyPresentationProps;
    billingDetailsWrapper?: GridItemProps;
    billingDetailsInnerWrapper?: GridContainerProps;
    billingLeftSection?: GridItemProps;
    billingRightSection?: GridItemProps;
    addressDetailsItem?: InjectableCss;
    invoiceContainer?: InjectableCss;
    creditMemoNumberText?: TypographyPresentationProps;
    creditMemoNumberValue?: TypographyPresentationProps;
    creditMemoNumberWrapper?: InjectableCss;
    viewCreditMemoModalPopUp?: ModalPresentationProps;
    viewCreditModalContainer?: GridContainerProps;
    messagePrintIcons?: GridItemProps;
    viewCreditMemoWrapper?: GridItemProps;
    viewCreditMemoHeading?: TypographyPresentationProps;
    viewCreditMemoNumber?: TypographyPresentationProps;
    viewCreditMemoHeader?: GridItemProps;
    addressHeader?: InjectableCss;
    addressDetails?: InjectableCss;
    addressHeading?: TypographyPresentationProps;
    informationWrapper?: InjectableCss;
    informationDetails?: InjectableCss;
    informationDetailsItems?: InjectableCss;
    addressDetailsItemHeading?: TypographyPresentationProps;
    invoiceContainerWrapper?: GridItemProps;
    invoiceFooter?: InjectableCss;
    shareModalPopupStyle?: ModalPresentationProps;
    shareModelRecipientsWrapper?: GridItemProps;
    shareEmailCheckBox?: CheckboxPresentationProps;
    shareEmailAddButton?: ButtonPresentationProps;
    shareSendEmailButton?: GridItemProps;
    shareRecipientText?: TypographyPresentationProps;
    shareEmailBtn?: ButtonPresentationProps;
    shareModalHeading?: TypographyPresentationProps;
    sendCheckBoxlabel?: TypographyPresentationProps;
    invoiceDataTable?: DataTablePresentationProps;
    invoiceDataTableHead?: DataTableHeadProps;
    invoiceDataTableHeader?: DataTableHeaderPresentationProps;
    invoiceDataTableBody?: DataTableBodyProps;
    invoiceDataTableRow?: DataTableRowProps;
    invoiceDataTableCell?: DataTableCellProps;
    invoiceTotalWrapper?: InjectableCss;
}

export const viewCreditTableStyle: ViewCreditTableStyle = {
    shareModalHeading: {
        variant: "h3",
        color: themeBackgrounds.white,
        css: css`
            margin-bottom: 0;
        `,
    },

    sendCheckBoxlabel: {
        color: themeBackgrounds.darkGray,
    },
    shareRecipientText: {
        color: themeBackgrounds.darkGray,
    },
    shareEmailBtn: {
        css: css`
            text-transform: uppercase;
        `,
    },
    viewCreditMemoModalPopUp: {
        cssOverrides: {
            modalBody: css`
                background: ${themeBackgrounds.offWhite};
            `,
        },

        closeButtonProps: {
            size: 24,
            css: css`
                background: none;
                top: 8px;
                border: none;
                position: absolute;
                right: 8px;

                &:hover {
                    background: none;
                    border: none;
                }
            `,
        },
    },
    shareModalPopupStyle: {
        cssOverrides: {
            modalBody: css`
                background: ${themeBackgrounds.offWhite};
            `,
            modalTitle: css`
                background: ${themeBackgrounds.black};
                color: ${themeBackgrounds.white};
            `,
        },
        closeButtonProps: {
            size: 24,
            color: themeBackgrounds.white,
            hoverMode: "none",
            css: css`
                top: 8px;
                border: none;
                position: absolute;
                right: 8px;

                span[class*="IconWrapper"] {
                    color: ${themeBackgrounds.white};
                }
                &,
                &:hover {
                    border: none;
                }
                &,
                &:hover,
                &:focus-visible,
                &:focus {
                    background: none;
                }
            `,
        },
    },
    informationWrapper: {
        css: css`
            padding: 5px;
            display: flex;
            width: 100%;
            align-items: center;
            background: ${themeBackgrounds.lightGray};
        `,
    },

    shareSendEmailButton: {
        width: 12,
        css: css`
            justify-content: end;
        `,
    },
    informationDetails: {
        css: css`
            padding: 5px;
        `,
    },

    shareEmailAddButton: {
        css: css`
            border-radius: 50%;
            height: 30px;
            width: 30px;
            justify-content: center;
            align-items: center;
            padding: 0;
            min-height: initial;
        `,
    },

    informationDetailsItems: {
        css: css`
            display: grid;
            margin: 4px 0;
            grid-template-columns: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            grid-template-columns: 220px auto;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    addressDetailsItemHeading: {
        weight: "bold",
    },

    shareModelRecipientsWrapper: {
        width: 12,
        css: css`
            flex-direction: column;
            padding: 15px 30px;
            gap: 10px;
            justify-content: center;
            > div {
                display: flex;
                flex-direction: column;
                gap: 10px;
                width: 100%;
                align-items: flex-start;
            }
        `,
    },
    addressHeader: {
        css: css`
            padding: 5px;
            display: flex;
            gap: 20px;
            align-items: center;
            background: ${themeBackgrounds.lightGray};
        `,
    },

    shareEmailCheckBox: {
        css: css`
            padding: 15px 0;
        `,
    },
    addressDetails: {
        css: css`
            padding: 5px;
            color: ${themeColors.primary.danaBlue};
        `,
    },

    addressHeading: {
        weight: "bold",
    },
    viewCreditModalContainer: {
        css: css`
            background: ${themeBackgrounds.white};
            padding: 0 20px;
        `,
    },
    messagePrintIcons: {
        width: 12,
        css: css`
            padding: 24px;
            justify-content: end;
            gap: 40px;
        `,
    },

    invoiceContainerWrapper: {
        width: 12,
        css: css`
            padding-top: 0;
        `,
    },
    viewCreditMemoHeader: {
        width: 12,
        css: css`
            > div > div {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`     
                            gap: 10px;
                        `,
                    ],
                    "max",
                )}
            }
        `
    },
    logoWrapper: {
        width: [12, 12, 2, 2, 2],
    },
    creditMemoAddress: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            justify-content: center;
        `,
    },

    viewCreditMemoNumber: {
        variant: "h3",
        color: themeBackgrounds.black,
        weight: "normal",
        css: css`
            margin-bottom: 0;
        `,
    },

    viewCreditMemoHeading: {
        variant: "h3",
        weight: "bold",
        color: themeColors.primary.richBlack,
        css: css`
            margin-bottom: 0;
        `,
    },

    creditMemoAddressHeading: {
        weight: "bold",

    },

    billingDetailsWrapper: {
        width: 12,
    },

    viewCreditMemoWrapper: {
        width: [12, 12, 4, 4, 4],

        css: css`
            flex-direction: column;
            align-items: flex-start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`                  
                            align-items: end;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    billingDetailsInnerWrapper: {
        gap: 0,
        css: css`
            > div {
                gap: 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`     
                            &[class*="GridOffset"] {
                                flex-wrap: nowrap;
                            }
                        `,
                    ],
                    "min",
                )}
            }

            
        `,
    },
    billingLeftSection: {
        width: [12, 12, 5, 5, 5],
        css: css`
            flex-direction: column;
            gap: 10px;
        `,
    },
    billingRightSection: {
        width: [12, 12, 7, 7, 7],
        css: css`
            flex-direction: column;
            border: 1px solid ${themeBackgrounds.darkGray};
        `,
    },
    addressDetailsItem: {
        css: css`
            border: 1px solid ${themeBackgrounds.darkGray};
            width: 100%;
        `,
    },

    invoiceDataTableHeader: {
        css: css`
            border: 1px solid ${themeBackgrounds.darkGray};
            padding: 8px;
            font-size: ${fontSizes.small};
            text-align: left;
            background-color: ${themeBackgrounds.lightGray};
            white-space: normal;
            word-wrap: break-word;
            overflow-wrap: break-word;

            &.invoice-table-material-item {
                width: 250px;
            }
        `,
    },

    invoiceDataTableCell: {
        css: css`
            border: 1px solid ${themeBackgrounds.darkGray};
            padding: 8px;
            font-size: 14px;
            text-align: left;
            &.text-right {
                text-align: right;
            }
            @media (max-width: 768px) {
                display: flex;
                justify-content: space-between;
                padding: 10px;
                font-size: ${fontSizes.small};
                border: none;
                border-bottom: 1px solid ${themeBackgrounds.darkGray};

                &:last-child {
                    border-bottom: none;
                }

                &:before {
                    content: attr(data-label);
                    font-weight: ${fontWeights.bold};
                }

                &.material-description {
                    height: auto;
                    flex-direction: column;
                    gap: 8px;

                    > br {
                        display: none;
                    }
                }
            }
        `,
    },

    invoiceTotalWrapper: {
        css: css`
            text-align: right;
            flex-direction: column-reverse;
            align-items: end;
            gap: 10px;
            border: 1px solid ${themeBackgrounds.darkGray};
            border-top: none;
            margin-bottom: 15px;
            padding: 15px;
            display: flex;
        `,
    },

    invoiceDataTable: {
        css: css`
            width: 100%;
            border-collapse: collapse;

            @media (max-width: 768px) {
                &.invoice-table thead {
                    display: none;
                }
            }
        `,
    },

    invoiceContainer: {
        css: css`
            padding: 0;
            max-width: 100%;
            width: 100%;
            overflow-x: auto;
        `,
    },
    // invoiceContainer: {
    // css: css`

    invoiceDataTableRow: {
        css: css`
            @media (max-width: 768px) {
                display: block;
                border: 1px solid ${themeBackgrounds.darkGray};
            }
        `,
    },

    invoiceFooter: {
        css: css`
            text-align: center;
            font-size: ${fontSizes.small};
            color: ${themeBackgrounds.darkGray};
            border: 1px solid ${themeBackgrounds.darkGray};
            padding: 10px 15px 15px;
            margin-top: 15px !important;
            justify-content: center;
            display: flex;
        `,
    },

    creditMemoNumberText: {
        variant: "h3",
        color: themeBackgrounds.lightGray,
        css: css`
            margin-bottom: 0;
        `,
    },

    creditMemoNumberValue: {
        variant: "h3",
        color: themeBackgrounds.darkGray,
        css: css`
            margin-bottom: 0;
        `,
    },

    creditMemoNumberWrapper: {
        css: css`
            display: flex;
            width: 100%;
            gap: 10px;
        `,
    },
};

const styles = viewCreditTableStyle;
const mapDispatchToProps = {
    sareCreditMomo
};


const mapStateToProps = (state: ApplicationStateDana) => ({
    viewCreditState: state.viewCreditState,
    viewCreditDetailsState: state.viewCreditDetailsState,
    language: state.context.session.language,
    username: state.context.session.userName,
    danaGeneralSettings: getDanaGeneralSettings(state),
    isEMEARegion: useIsEmea(state),
});

type Props = ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;
const ViewCreditDetails: React.FC<Props> = ({ language, isEMEARegion, username, viewCreditDetailsState, sareCreditMomo, danaGeneralSettings }) => {
    const [shareEmails, setShareEmails] = useState<string[]>(['']);
    const [sendingMail, setSendingMail] = useState(false);
    const [isOpenShare, setIsOpenShare] = useState(false);
    const [sendCopy, setSendCopy] = useState(false);
    const validateEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const toasterContext = React.useContext(ToasterContext);
    const canSendEmail = () => {
        const hasValidEmail = shareEmails.some(email => validateEmail(email));
        return hasValidEmail;
    };

    const handleSendCopyChange = (event: any) => {
        event.preventDefault();
        setSendCopy(!sendCopy);
    };
    const handleShareModalPopup = () => {
        setIsOpenShare(!isOpenShare);
    };
    const [creditMemoDetails, setCreditMemoDetails] = useState<CreditMemoDetails>();
    const [salseOrgDetails, setSalseOrgDetails] = useState<SalseOrgDetails>();
    const handleShareModalPopupClose = () => {
        setIsOpenShare(!isOpenShare);
    };

    useEffect(() => {
        setCreditMemoDetails(viewCreditDetailsState?.creditMemoDetails);
        setSalseOrgDetails(viewCreditDetailsState?.salseOrgDetails)
    }, [viewCreditDetailsState]);

    const totalNetAmount = creditMemoDetails?.invoiceInfo?.reduce((sum, item) => {
        return sum + (item.netAmount || 0);
    }, 0);
    const handlePrintCredit = () => {
        if (creditMemoDetails && creditMemoDetails.creditMemoNumber) {
            printCreditMemoPdf(creditMemoDetails.creditMemoNumber);
        }
    }

    const handleAddEmail = () => {
        setShareEmails([...shareEmails, '']);
    };

    const handleRemoveAccount = (index: number) => {
        const updatedAccounts = shareEmails.filter((_, i) => i !== index);
        setShareEmails(updatedAccounts);

    };
    const handleCustomerInputChange = (index: number, value: string) => {
        const updatedAccounts = [...shareEmails];
        updatedAccounts[index] = value;
        setShareEmails(updatedAccounts);
    };
    const handleSendEmail = () => {

        const emailsToSend = shareEmails.filter(email => email.trim().length > 0);

        const allValid = emailsToSend.every(email => validateEmail(email));
        if (!allValid) {
            return;
        }
        try {
            setSendingMail(true);
            let shareEmailList: string[] = shareEmails;
            if (sendCopy) {
                shareEmailList = [...(shareEmailList || []), username];
            }
            if (creditMemoDetails?.creditMemoNumber && shareEmails.length > 0) {
                sareCreditMomo({
                    creditMemoNumber: creditMemoDetails.creditMemoNumber,
                    shareEmails: shareEmailList,
                    onSuccess(result: any) {
                        if (result.shareCreditResult.success === true) {
                            toasterContext.addToast({
                                body: translate("Email sent successfully."),
                                messageType: "success",
                                isFocusAfterMount: true,
                            });
                        } else {
                            toasterContext.addToast({
                                body: translate("There is an error while sent an email."),
                                messageType: "danger",
                                isFocusAfterMount: true,
                            });
                        }
                        setSendingMail(false);
                        handleShareModalPopupClose();
                    }
                });
            }

        } catch (e) {
            // Handle error...
        }
    };

    return (
        <>
            <GridContainer gap={0}>
                <GridItem {...styles.messagePrintIcons}>
                    <Button variant="tertiary" onClick={handleShareModalPopup}> <Icon src={MessageIcon} size={16} ></Icon></Button>

                    <Modal
                        isOpen={isOpenShare}
                        handleClose={handleShareModalPopupClose}
                        headline={<Typography {...styles.shareModalHeading}>{translate("Share")}</Typography>}
                        size={600}
                        {...styles.shareModalPopupStyle}
                    >
                        <LoadingOverlay loading={sendingMail}>
                            <CheckboxGroup>
                                <Checkbox
                                    {...styles.shareEmailCheckBox}
                                    checked={sendCopy}
                                    onChange={handleSendCopyChange}
                                >
                                    <Typography {...styles.sendCheckBoxlabel}>{translate("Send me a copy ")} {username}</Typography>
                                </Checkbox>
                            </CheckboxGroup>
                            <GridContainer gap={0}>
                                <GridItem {...styles.shareModelRecipientsWrapper}>
                                    <Typography {...styles.shareRecipientText}>{translate("Recipients")}</Typography>
                                    {shareEmails.map((email, index) => (
                                        <StyledWrapper key={`email-${index}`}>
                                            <TextField
                                                name={`email-${index}`}
                                                id={`email-${index}`}
                                                autoComplete={`section-recipient-${index} email`}
                                                type="email"
                                                value={email}
                                                onChange={(e) => handleCustomerInputChange(index, e.target.value)}
                                                maxLength={256}
                                                required
                                                placeholder={translate("Enter Email")}
                                            />

                                            <Button onClick={() => handleRemoveAccount(index)} >{translate("Remove")}</Button>
                                        </StyledWrapper>
                                    ))}
                                    <Button {...styles.shareEmailAddButton}>
                                        <Icon onClick={handleAddEmail} src={PlusIcon} size={16}></Icon>
                                    </Button>
                                </GridItem>

                                <GridItem {...styles.shareSendEmailButton}>
                                    <Button onClick={handleSendEmail} disabled={!canSendEmail()}  {...styles.shareEmailBtn}>{translate("Send Email")}</Button>
                                </GridItem>
                            </GridContainer>
                          
                        </LoadingOverlay>
                    </Modal>
                    <Button variant="tertiary" onClick={handlePrintCredit}><Icon src={PrintIcon} size={16}></Icon></Button>
                </GridItem>
            </GridContainer>
           

            <GridContainer {...styles.viewCreditModalContainer}>
                <GridItem className="mail-print-icon-wrapper"></GridItem>

                <GridItem className="header-section" {...styles.viewCreditMemoHeader}>
                    <GridContainer gap={10}>
                        <GridItem {...styles.logoWrapper}>
                            <Img src={danaGeneralSettings?.emailLogo || "/UserFiles/Images/Danaaftermarket.png"}></Img>
                        </GridItem>
                        <GridItem {...styles.creditMemoAddress}>
                            <Typography {...styles.creditMemoAddressHeading}>
                                {salseOrgDetails?.orgName}
                            </Typography>
                            <Typography {...styles.creditMemoAddressDescription}>
                                <Typography>{salseOrgDetails?.orgAddress}</Typography>
                            </Typography>
                            <Typography {...styles.creditMemoAddressDescription}>
                            {salseOrgDetails?.country}
                            </Typography>
                            <Typography {...styles.creditMemoAddressDescription}>
                                {salseOrgDetails?.siteName}
                            </Typography>
                        </GridItem>
                        <GridItem {...styles.viewCreditMemoWrapper}>
                            <Typography {...styles.viewCreditMemoHeading}>{translate("Credit Memo")}</Typography>
                            <Typography {...styles.viewCreditMemoNumber}>{creditMemoDetails?.creditMemoNumber}</Typography>
                        </GridItem>
                    </GridContainer>
                </GridItem>

                <GridItem {...styles.billingDetailsWrapper}>
                    <GridContainer {...styles.billingDetailsInnerWrapper}>
                        <GridItem className="left-section" {...styles.billingLeftSection}>
                            <StyledWrapper {...styles.addressDetailsItem}>
                                <StyledWrapper {...styles.addressHeader}>
                                    <Typography className="text-body-md" {...styles.addressHeading}>
                                        {translate("Bill-To-Party")}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.billTo}</Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.addressDetails}>
                                    <Typography as="p">{creditMemoDetails?.billName}</Typography>
                                    <Typography as="p">{creditMemoDetails?.billAddress1}</Typography>
                                    <Typography as="p">
                                        {creditMemoDetails?.billCity} {creditMemoDetails?.billState}{" "}
                                        {creditMemoDetails?.billZip}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.billCountry}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper {...styles.addressDetailsItem}>
                                <StyledWrapper {...styles.addressHeader}>
                                    <Typography className="text-body-md" {...styles.addressHeading}>
                                        {translate("Ship-To-Party")}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.shipTo}</Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.addressDetails}>
                                    <Typography as="p">{creditMemoDetails?.shipName}</Typography>
                                    <Typography as="p">{creditMemoDetails?.shipAddress1}</Typography>
                                    <Typography as="p">
                                        {creditMemoDetails?.shipCity} {creditMemoDetails?.shipState}{" "}
                                        {creditMemoDetails?.shipZip}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.shipCountry}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                            <StyledWrapper {...styles.addressDetailsItem}>
                                <StyledWrapper {...styles.addressHeader}>
                                    <Typography className="text-body-md" {...styles.addressHeading}>
                                        {translate("Sold-To-Party")}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.soldToCustomerId ?? creditMemoDetails?.billTo}</Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.addressDetails}>
                                    <Typography as="p">{creditMemoDetails?.soldToName ?? creditMemoDetails?.billName}</Typography>
                                    <Typography as="p">{creditMemoDetails?.soldToAddress1 ?? creditMemoDetails?.billAddress1}</Typography>
                                    <Typography as="p">
                                        {creditMemoDetails?.soldToCity ?? creditMemoDetails?.billCity} {creditMemoDetails?.soldToState ?? creditMemoDetails?.billState}{" "}
                                        {creditMemoDetails?.soldToZip ?? creditMemoDetails?.billZip}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.soldToCountry ?? creditMemoDetails?.billCountry}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>

                            <StyledWrapper {...styles.addressDetailsItem}>
                                <StyledWrapper {...styles.addressHeader}>
                                    <Typography className="text-body-md" {...styles.addressHeading}>
                                        {translate("Shipping Plant Address")}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.addressDetails}>
                                    <Typography as="p">{creditMemoDetails?.shipPlantName}</Typography>
                                    <Typography as="p">{creditMemoDetails?.shipPlantAddress1}</Typography>
                                    <Typography as="p">
                                        {creditMemoDetails?.shipPlantCity} {creditMemoDetails?.shipPlantState}{" "}
                                        {creditMemoDetails?.shipPlantZip}
                                    </Typography>
                                    <Typography as="p">{creditMemoDetails?.shipPlantCountry}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                            {(creditMemoDetails?.remitToName || creditMemoDetails?.remitToAddress1) && (
                                <StyledWrapper {...styles.addressDetailsItem}>
                                    <StyledWrapper {...styles.addressHeader}>
                                        <Typography className="text-body-md" {...styles.addressHeading}>
                                            {translate("Remit To")}
                                        </Typography>
                                    </StyledWrapper>

                                    <StyledWrapper {...styles.addressDetails}>
                                        <Typography as="p">{creditMemoDetails?.remitToName}</Typography>
                                        <Typography as="p">{creditMemoDetails?.remitToAddress1}</Typography>
                                        <Typography as="p">
                                            {creditMemoDetails?.remitToCity} {creditMemoDetails?.remitToState}{" "}
                                            {creditMemoDetails?.remitToZip}
                                        </Typography>
                                        <Typography as="p">{creditMemoDetails?.remitToCountry}</Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}

                        </GridItem>
                        <GridItem className="left-section" {...styles.billingRightSection}>
                            <StyledWrapper {...styles.informationWrapper}>
                                <Typography className="text-body-md" {...styles.addressHeading}>
                                    {translate("Information")}
                                </Typography>
                            </StyledWrapper>

                            <StyledWrapper {...styles.informationDetails}>
                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Invoice No:")}
                                    </Typography>
                                    <Typography>{creditMemoDetails?.invoiceNumber}</Typography>
                                </StyledWrapper>

                                {creditMemoDetails?.invoiceDate && (
                                    <StyledWrapper {...styles.informationDetailsItems}>
                                        <Typography as="p" {...styles.addressDetailsItemHeading}>
                                            {translate("Invoice Date:")}
                                        </Typography>
                                        <Typography>
                                            {creditMemoDetails?.invoiceDate && creditMemoDetails?.invoiceDate
                                                ? getLocalizedDateTime({
                                                    dateTime: new Date(creditMemoDetails?.invoiceDate),
                                                    language,
                                                })
                                                : ""}
                                        </Typography>
                                    </StyledWrapper>
                                )}

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Reference Invoice No / Date:")}
                                    </Typography>
                                    <Typography>
                                        {creditMemoDetails?.originalInvoiceNumber}{" "}
                                        {creditMemoDetails?.originalInvoiceDate ? "/" : ""}{" "}
                                        {creditMemoDetails?.originalInvoiceDate
                                            ? getLocalizedDateTime({
                                                dateTime: new Date(creditMemoDetails?.originalInvoiceDate),
                                                language,
                                            })
                                            : ""}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Delivery No / Date:")}{" "}
                                    </Typography>
                                    <Typography>
                                        {" "}
                                        {creditMemoDetails?.deliveryNumber} {creditMemoDetails?.deliveryDate ? "/" : ""}{" "}
                                        {creditMemoDetails?.deliveryDate
                                            ? getLocalizedDateTime({
                                                dateTime: new Date(creditMemoDetails?.deliveryDate),
                                                language,
                                            })
                                            : ""}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Info Ref Order No / Date:")}
                                    </Typography>
                                    <Typography>
                                        {creditMemoDetails?.documentNumber}  {creditMemoDetails?.documentDate ? "/" : ""}  {creditMemoDetails?.documentDate
                                            ? getLocalizedDateTime({
                                                dateTime: new Date(creditMemoDetails?.documentDate),
                                                language,
                                            })
                                            : ""}
                                    </Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Customer Account No:")}
                                    </Typography>
                                    <Typography>{creditMemoDetails?.billTo}</Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Currency")}
                                    </Typography>
                                    <Typography>{creditMemoDetails?.currency}</Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Term of Payment:")}
                                    </Typography>
                                    <Typography>{creditMemoDetails?.termsDescription}</Typography>
                                </StyledWrapper>

                                <StyledWrapper {...styles.informationDetailsItems}>
                                    <Typography as="p" {...styles.addressDetailsItemHeading}>
                                        {translate("Incoterm:")}
                                    </Typography>
                                    <Typography>{creditMemoDetails?.incotermsDescription}</Typography>
                                </StyledWrapper>
                            </StyledWrapper>
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.invoiceContainerWrapper}>
                    <StyledWrapper className="invoice-container" {...styles.invoiceContainer}>
                        <DataTable className="invoice-table" {...styles.invoiceDataTable}>
                            <DataTableHead {...styles.invoiceDataTableHead} className="thead-invoice">
                                <DataTableHeader {...styles.invoiceDataTableHeader} className="invoice-table-item">
                                    {translate("Item")}
                                </DataTableHeader>
                                <DataTableHeader
                                    {...styles.invoiceDataTableHeader}
                                    className="invoice-table-material-item"
                                >
                                    {translate("Material/Description")}
                                </DataTableHeader>
                                <DataTableHeader {...styles.invoiceDataTableHeader}>
                                    {translate("CustPO / ShipToPO")}
                                </DataTableHeader>
                                <DataTableHeader {...styles.invoiceDataTableHeader} className="invoice-table-quantity">
                                    {translate("Quantity")}
                                </DataTableHeader>
                                <DataTableHeader {...styles.invoiceDataTableHeader}>{`${translate("Unit Price")} (${creditMemoDetails?.currency ?? ""
                                    })`}</DataTableHeader>
                                {!isEMEARegion && (
                                    <>
                                        <DataTableHeader {...styles.invoiceDataTableHeader}>{`${translate(
                                            "Unit Tariff Fee",
                                        )} (${creditMemoDetails?.currency ?? ""})`}</DataTableHeader>
                                        <DataTableHeader {...styles.invoiceDataTableHeader}>{`${translate(
                                            "Unit Core Deposit",
                                        )} (${creditMemoDetails?.currency ?? ""})`}</DataTableHeader>
                                    </>)}
                                <DataTableHeader {...styles.invoiceDataTableHeader}>{`${translate("Extended Price")} (${creditMemoDetails?.currency ?? ""
                                    })`}</DataTableHeader>
                            </DataTableHead>
                            <DataTableBody {...styles.invoiceDataTableBody}>
                                {creditMemoDetails?.invoiceInfo?.map((item, index) => {
                                    const lineNumberString = item.lineNumber;
                                    const lineNumberNum = parseInt(lineNumberString, 10); // 10 (number)
                                    const tariffInfo = item.partPriceInfo.find(
                                        price => price.priceType.toLowerCase() === "tariff",
                                    );
                                    const tariffAmount = tariffInfo ? tariffInfo.amount : 0;

                                    const coreFee = item.partPriceInfo.find(price => price.priceType.toLowerCase() === "core fee");
                                    const coreFeeAmount = coreFee ? coreFee.amount : 0;
                                    return (
                                        <DataTableRow
                                            key={item.identifier ?? index}
                                            {...styles.invoiceDataTableRow}
                                            className="row-invoice"
                                        >
                                            <DataTableCell
                                                className="td-item"
                                                data-label={translate("Item")}
                                                {...styles.invoiceDataTableCell}
                                            >
                                                {lineNumberNum}
                                            </DataTableCell>
                                            <DataTableCell
                                                {...styles.invoiceDataTableCell}
                                                data-label={translate("Material/Description")}
                                                className="material-description"
                                            >
                                                <Typography>{item?.partNumber}</Typography>
                                                <br />
                                                <Typography>{item?.partDescription}</Typography>
                                                <br />
                                                {item.customerPartNumber ? (
                                                    <Typography>
                                                        {translate("Customer Part No:")}
                                                        {item.customerPartNumber}
                                                    </Typography>
                                                ) : (
                                                    ""
                                                )}
                                                <br />

                                                <Typography>
                                                    <>
                                                        {translate("Invoice number:")} {item.invoiceNumber}{" "}
                                                        {translate("from")}{" "}
                                                        {item.invoiceDate
                                                            ? getLocalizedDateTime({
                                                                dateTime: new Date(item.invoiceDate),
                                                                language,
                                                            })
                                                            : ""}
                                                    </>
                                                </Typography>
                                            </DataTableCell>
                                            <DataTableCell {...styles.invoiceDataTableCell} data-label={translate("CustPO / ShipToPO")}>{item?.poNumber}</DataTableCell>
                                            <DataTableCell {...styles.invoiceDataTableCell} data-label={translate("Quantity")}>{item?.quantityShipped} {item?.unitOfMeasure}</DataTableCell>
                                            <DataTableCell className="text-right" {...styles.invoiceDataTableCell} data-label={`${translate("Unit Price")} (${creditMemoDetails?.currency ?? ''})`}>{isEMEARegion?formatDecimal(item?.pricePerUnit,{locale:"fr-FR"}):formatDecimal(item?.pricePerUnit)}</DataTableCell>
                                            {!isEMEARegion && (<>
                                                <DataTableCell className="text-right" {...styles.invoiceDataTableCell} data-label={`${translate("Unit Tariff Fee")} (${creditMemoDetails?.currency ?? ''})`}>{formatDecimal(tariffAmount)}</DataTableCell>
                                                <DataTableCell className="text-right" {...styles.invoiceDataTableCell} data-label={`${translate("Unit Core Deposit")} (${creditMemoDetails?.currency ?? ''})`}>{formatDecimal(coreFeeAmount)}</DataTableCell>
                                            </>)}
                                            <DataTableCell className="text-right" {...styles.invoiceDataTableCell} data-label={`${translate("Extended Price")} (${creditMemoDetails?.currency ?? ''})`}>{isEMEARegion?formatDecimal(item?.netAmount,{locale:"fr-FR"}):formatDecimal(item?.netAmount)}</DataTableCell>

                                        </DataTableRow>
                                    );
                                })}
                            </DataTableBody>
                        </DataTable>
                        <StyledWrapper className="invoice-total" {...styles.invoiceTotalWrapper}>
                            <Typography as="p">
                                <strong>
                                    {" "}
                                    {`${translate("Item(s) Total")} (${creditMemoDetails?.currency ?? ""}):`}
                                </strong>{" "}
                                {isEMEARegion?formatDecimal(String(totalNetAmount),{locale:"fr-FR"}):formatDecimal(String(totalNetAmount))}
                            </Typography>
                            <Typography as="p">
                                <strong>
                                    {translate("Total")} ({creditMemoDetails?.currency ?? "USD"}):{" "}
                                </strong>{" "}
                                {isEMEARegion?formatDecimal(String(totalNetAmount),{locale:"fr-FR"}):formatDecimal(String(totalNetAmount))}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper  {...styles.invoiceFooter} className="invoice-footer">

                            <Typography>{salseOrgDetails?.orgName} {salseOrgDetails?.orgAddress}, {salseOrgDetails?.country}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            </GridContainer >


        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCreditDetails);
